import React from "react";
import { Header, SubFooter } from "Atoms/";
import Link from "next/link";

const Index = () => {
  return (
    <>
      <Header
        classType="header-int"
        title1="Diamond Head"
        title2="State Monument"
        url="diamondhead"
      />
      <div className="container" role="main">
        <div className="row row-padding">
          <div className="col-xl-12">
            <h2>About Diamond Head State Monument Reservations</h2>
            <p>
            Aloha and welcome to the official website for the Diamond Head State Monument Online Reservation System. From this website you will be able to reserve and purchase parking (if necessary) and entry tickets to the park.
            </p>
            <p>
            Reservations may be made up to 30 days in advance. Because the park gets busy at certain times during the day and may sell out, please book your reservations as soon as possible to avoid missing out.
            </p>
            <p>
            Please arrive within the first 30 minutes of your reservation period. If you arrive after 30 minutes into your reservation period, you may be denied access and/or parking. There will be no refunds for no-shows or late arrivals. If you purchase parking reservations, be aware that you must exit the park by the end time of your reservation period. This is to accommodate those arriving in later timeslots, as parking in Diamond Head is very limited.
            </p>
            
            <p>
              Parking and entry fees must be purchased online, at this website.
              Persons without a reservation will be turned away.
            </p>
            <b >Refund/Changes policies:</b>
            <p>
            Refunds are allowed up to 3 days prior to your entry date.  Changes to your reservation may be made up until the day before your reservation (midnight Hawaiʻi time) and will be allowed so long as space is available on your preferred date/time.  Cancellation ($5) and service fees may be applied to these requests (no service fee on changes resulting in no cost change).  Requests can be made by clicking on the Change/Cancel/View Your Reservation link on the reservations page.  A change resulting in a lesser cost will result in a refund only if the change is requested 3 days or more before the entry date. 
            </p>
            <p>
              <i>
              *State of Hawaiʻi residents are exempt from the fee/reservation requirement – proof of state residency is required at time of entry. Visitors accompanying State of Hawaiʻi residents to visit Diamond Head State Monument are not exempt from the entry fees and must purchase in advance. 
              </i>
            </p>
            <p>
              <i>
              *Any commercial carriers or tour companies caught trying to use the visitor reservation system instead of the PUC reservation system may be banned from the park for up to one year.

              </i>
            </p>
            <p>
              <Link href="/diamondhead">
                <a>CLICK HERE TO PROCEED TO RESERVATION SYSTEM</a>
              </Link>{" "}
            </p>
          </div>
        </div>
      </div>
      <SubFooter name="Diamond Head State Monument" url="diamondhead" />
    </>
  );
};

export default Index;
